import "./plugins/filters";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import i18n from "./plugins/i18n";
import validator from "./plugins/validator";
import store from "./store";
import axios from "./plugins/axios";
import "webrtc-adapter";
import "@mdi/font/scss/materialdesignicons.scss";
import "./plugins/analytics";
import "./plugins/gmap";
import LoadScript from "vue-plugin-load-script";
import VBtn from "./plugins/colored-button";

import VueSocialSharing from "vue-social-sharing";
import WebFont from "webfontloader";

WebFont.load({
  google: {
    families: ["Roboto:100,300,400,500,700,900"],
  },
});

Vue.config.productionTip = false;

Vue.use(VueSocialSharing);

new Vue({
  router,
  vuetify,
  i18n,
  validator,
  store,
  axios,
  render: (h) => h(App),
}).$mount("#app");

Vue.use(LoadScript);
Vue.component("v-btn", VBtn);
